import {CSS} from '@stitches/react';

export const alertRootCss: CSS = {
	'& [data-alert-content]': {
		width: 508,
		gap: 20,
	},
};
